import React, { createContext } from "react";

import { PatientCreationDirectives } from "@/models/CarePlanDirectivesModel.ts";

const PatientCreationContext = createContext<PatientCreationDirectives | null>(null);

export const PatientCreationProvider: React.FC<{
  patientCreationDirectives: PatientCreationDirectives;
  children: React.ReactNode;
}> = ({ patientCreationDirectives, children }) => {
  return (
    <PatientCreationContext.Provider value={patientCreationDirectives}>{children}</PatientCreationContext.Provider>
  );
};

export const usePatientCreationContext = () => {
  const context = React.useContext(PatientCreationContext);
  if (!context) {
    throw new Error("usePatientCreationContext must be used within a PatientCreationProvider");
  }
  return context;
};
